import React from 'react';
import styles from './index.module.scss';
import FooterTextComponent from '../../footer/footer_text_component';
import DescriptionComponent from '../../../long_text_components/description_component';
import UnknownLongText from '../../../long_text_components/unknown_long_text';
import FooterSocialIconsBlock from '../../footer/footer_social_icons_block';
import VideoComponent from '../../../video_components/video_component';
import UnknownVideo from '../../../video_components/unknown_video';

const ContactsBlock = ({ blockData, path_to_folder, blockIndex, compactDescription = false, hideMetaDisclaimer = false }) => {
  const isEmpty = (value) => {
    if (!value) return true;
    const trimmed = String(value).trim().toLowerCase();
    return trimmed === '' || trimmed === 'none';
  };

  const contactLinks = React.useMemo(() => {
    if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
      return [];
    }
    return blockData.block_content
      .filter((content) => (content.cotent_tag === 'contact_link' || content.content_tag === 'contact_link') && !isEmpty(content.content_text))
      .map((content) => content.content_text);
  }, [blockData]);

  const renderContent = (content) => {
    if (content.cotent_type === 'text' || content.content_type === 'text') {
      if (content.cotent_tag === 'contact_link' || content.content_tag === 'contact_link') {
        return null;
      }
      return (
        <FooterTextComponent
          contentText={content.content_text}
          contentTag={content.cotent_tag || content.content_tag}
          contentName={content.cotent_name || content.content_name}
        />
      );
    }

    if (content.cotent_type === 'long_text' || content.content_type === 'long_text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'description':
          return (
            <DescriptionComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
              compact={compactDescription}
            />
          );
        default:
          return (
            <UnknownLongText
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }

    if (content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block') {
      return (
        <FooterSocialIconsBlock
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name || content.content_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
          links={contactLinks}
          hideMetaDisclaimer={hideMetaDisclaimer}
        />
      );
    }

    if (content.cotent_type === 'video' || content.content_type === 'video') {
      switch (content.cotent_tag || content.content_tag) {
        case 'video':
          return (
            <VideoComponent
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownVideo
              contentData={content}
              contentText={content.content_text}
              contentName={content.cotent_name || content.content_name}
              imgName={content.img_name}
              imgsNames={content.imgs_names}
              videoName={content.video_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }

    return null;
  };

  if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
    return null;
  }

  const imageContent = blockData.block_content.find(
    (content) => (content.cotent_type === 'img' || content.content_type === 'img') && !isEmpty(content.img_name),
  );
  const titleContent = blockData.block_content.find(
    (content) =>
      (content.cotent_type === 'text' || content.content_type === 'text') &&
      (content.cotent_tag === 'title' || content.content_tag === 'title') &&
      !isEmpty(content.content_text),
  );
  const linkContent = blockData.block_content.find(
    (content) =>
      (content.cotent_type === 'text' || content.content_type === 'text') &&
      (content.cotent_tag === 'link' || content.content_tag === 'link') &&
      !isEmpty(content.content_text),
  );

  const otherContent = blockData.block_content.filter((content) => {
    if (content.cotent_type === 'img' || content.content_type === 'img') return false;
    if ((content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'title' || content.content_tag === 'title')) return false;
    if ((content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'link' || content.content_tag === 'link')) return false;
    if (content.cotent_tag === 'contact_link' || content.content_tag === 'contact_link') return false;
    if ((content.cotent_type === 'text' || content.content_type === 'text') && isEmpty(content.content_text)) return false;
    if ((content.cotent_type === 'long_text' || content.content_type === 'long_text') && isEmpty(content.content_text)) return false;
    if ((content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block') && isEmpty(content.imgs_names)) return false;
    if ((content.cotent_type === 'video' || content.content_type === 'video') && isEmpty(content.video_name)) return false;
    return true;
  });

  const mapIndex = otherContent.findIndex((content) => content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block');
  let contentBeforeMap = [];
  let mapContent = null;
  let contentAfterMap = [];
  if (mapIndex !== -1) {
    contentBeforeMap = otherContent.slice(0, mapIndex);
    mapContent = otherContent[mapIndex];
    contentAfterMap = otherContent.slice(mapIndex + 1);
  } else {
    contentBeforeMap = otherContent;
  }

  const linkUrl = linkContent ? `https://${linkContent.content_text}` : null;
  const shouldRenderSpecialBlock = imageContent || titleContent || linkUrl;

  if (
    !shouldRenderSpecialBlock &&
    contentBeforeMap.length === 0 &&
    !mapContent &&
    contentAfterMap.length === 0
  ) {
    return null;
  }

  return (
    <div className={styles.contactsBlock}>
      <div className={styles.contentContainer}>
        {shouldRenderSpecialBlock && titleContent && linkUrl ? (
          <a href={linkUrl} target='_blank' rel='noopener noreferrer' className={styles.clickableBlock}>
            {imageContent &&
              (() => {
                const processedImgName =
                  imageContent.img_name && imageContent.img_name.includes('\\')
                    ? imageContent.img_name.substring(imageContent.img_name.lastIndexOf('\\') + 1)
                    : imageContent.img_name;
                return (
                  <div className={styles.imageWrapper}>
                    <img src={path_to_folder + processedImgName} alt='Контакт' className={styles.contactImage} />
                  </div>
                );
              })()}
            <div className={styles.titleWrapper}>
              <span className={styles.titleText}>{titleContent.content_text}</span>
            </div>
          </a>
        ) : shouldRenderSpecialBlock && titleContent ? (
          <div className={styles.nonClickableBlock}>
            {imageContent &&
              (() => {
                const processedImgName =
                  imageContent.img_name && imageContent.img_name.includes('\\')
                    ? imageContent.img_name.substring(imageContent.img_name.lastIndexOf('\\') + 1)
                    : imageContent.img_name;
                return (
                  <div className={styles.imageWrapper}>
                    <img src={path_to_folder + processedImgName} alt='Контакт' className={styles.contactImage} />
                  </div>
                );
              })()}
            <div className={styles.titleWrapper}>
              <span className={styles.titleText}>{titleContent.content_text}</span>
            </div>
          </div>
        ) : shouldRenderSpecialBlock && linkUrl ? (
          <a href={linkUrl} target='_blank' rel='noopener noreferrer' className={styles.clickableBlock}>
            <div className={styles.titleWrapper}>
              <span className={styles.titleText}>{linkContent.content_text}</span>
            </div>
          </a>
        ) : null}

        {contentBeforeMap.length > 0 && (
          <div className={styles.otherContentContainer}>
            {contentBeforeMap.map((content, index) => {
              const renderedContent = renderContent(content);
              if (!renderedContent) return null;
              return (
                <div key={`before-map-${index}`} className={styles.contentWrapper}>
                  {renderedContent}
                </div>
              );
            })}
          </div>
        )}

        {mapContent && <div className={styles.mapContainer}>{renderContent(mapContent)}</div>}

        {contentAfterMap.length > 0 && (
          <div className={styles.otherContentContainer}>
            {contentAfterMap.map((content, index) => {
              const renderedContent = renderContent(content);
              if (!renderedContent) return null;
              return (
                <div key={`after-map-${index}`} className={styles.contentWrapper}>
                  {renderedContent}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactsBlock;
